import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import {
  type C5Portfolio,
  porfolios_columns,
  columnVisibilityInit,
} from "./columns";
import { type FilterC5PortfoliosSchema, FilterC5Portfolios } from "./filter";

const client = Clients.C5;
const table_name = Tables.C5_PORTFOLIOS;

export const C5PortfoliosTable = () => {
  return (
    <Table<C5Portfolio, FilterC5PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterC5Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
